import {createTheme, Theme} from '@mui/material/styles';

/**
 * Material Design 3 theme tokens and component configurations
 * for the Odia Digitise Platform.
 */
export const md3Theme: Theme = createTheme({
  palette: {
    primary: {
      main: '#0b57d0',
      light: '#d3e3fd',
      dark: '#0842a0',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#00639b',
      light: '#c2e7ff',
      dark: '#004a75',
      contrastText: '#ffffff',
    },
    error: {
      main: '#b3261e',
      light: '#f9dedc',
      dark: '#601410',
      contrastText: '#ffffff',
    },
    background: {
      default: '#f6f8fc',
      paper: '#ffffff',
    },
    text: {
      primary: '#1d1b20',
      secondary: '#49454f',
    },
    divider: '#c4c7c5',
  },
  typography: {
    fontFamily:
      "'odia', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
    h1: {
      fontSize: '2rem',
      fontWeight: 400,
      lineHeight: 1.25,
    },
    h2: {
      fontSize: '1.5rem',
      fontWeight: 500,
      lineHeight: 1.3,
    },
    h3: {
      fontSize: '1.25rem',
      fontWeight: 500,
      lineHeight: 1.35,
    },
    h4: {
      fontSize: '1.125rem',
      fontWeight: 500,
      lineHeight: 1.4,
    },
    body1: {
      fontSize: '1rem',
      lineHeight: 1.5,
    },
    body2: {
      fontSize: '0.875rem',
      lineHeight: 1.43,
    },
    button: {
      textTransform: 'none',
      fontWeight: 500,
    },
  },
  shape: {
    borderRadius: 8,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 100,
          textTransform: 'none',
          padding: '8px 20px',
        },
      },
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          borderRadius: '50%',
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          fontWeight: 500,
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          borderBottom: '1px solid #c4c7c5',
        },
      },
    },
  },
});

export default md3Theme;
